
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";

class Anchor {
  title = "";
  tag = "";
  level = 1; //1:标题 2:子标题
}

@Component
export default class Directory extends Vue {
  @Prop({ type: String, default: "" }) screenScrollTo!: string; //用户屏幕滚动到指定位置
  activeIndex = 0;

  @Watch("screenScrollTo")
  ss() {
    this.activeIndex = this.anchorList.findIndex(
      (item: Anchor) => item.tag === this.screenScrollTo
    );
  }

  anchorList: Anchor[] = []; //后续其他页面调用可以传入使用
  created() {
    this.anchorList = [
      { title: "面试设置", tag: "面试设置", level: 1 },
      { title: "时间设置", tag: "时间设置", level: 2 },
      { title: "面试官形象", tag: "面试官形象", level: 2 },
      { title: "登记信息", tag: "登记信息", level: 2 },
      { title: "页面设置", tag: "页面设置", level: 1 },
      { title: "宣传页", tag: "宣传页", level: 2 },
      { title: "须知页", tag: "须知页", level: 2 },
      { title: "结束页", tag: "结束页", level: 2 },
      { title: "高级设置", tag: "高级设置", level: 1 }
    ];
  }
  handleClick(item: any, i: number) {
    // this.activeIndex = i;
    this.$emit("change", item.tag);
  }
}
